// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graphic{
    width: 100%;
}

.graphic_svg{
    width: 100%;
}

.graphic_path{
    stroke: #FFA825;
    stroke-width: 2px;
}

.graphic_path_end{
    stroke: #AFAFAF;
    stroke-width: 2px;
    stroke-dasharray: 5, 5;
}

.graphic_path_median{
    stroke: #f00;
    stroke-width: 2px;
}

.graphic_text_small{
    font-weight: 400;
    font-size: 8px;
    line-height: 8px;
}

.graphic_grid{
    stroke: #AFAFAF;
    stroke-width: 1px;
    stroke-dasharray: 5, 5;
}

.graphic_grid_text{
    fill: #000000;
    text-anchor: middle;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 10px;
}

.graphic_grid_value{
    fill: #000;
    font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/components/graphic/Graphic.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".graphic{\n    width: 100%;\n}\n\n.graphic_svg{\n    width: 100%;\n}\n\n.graphic_path{\n    stroke: #FFA825;\n    stroke-width: 2px;\n}\n\n.graphic_path_end{\n    stroke: #AFAFAF;\n    stroke-width: 2px;\n    stroke-dasharray: 5, 5;\n}\n\n.graphic_path_median{\n    stroke: #f00;\n    stroke-width: 2px;\n}\n\n.graphic_text_small{\n    font-weight: 400;\n    font-size: 8px;\n    line-height: 8px;\n}\n\n.graphic_grid{\n    stroke: #AFAFAF;\n    stroke-width: 1px;\n    stroke-dasharray: 5, 5;\n}\n\n.graphic_grid_text{\n    fill: #000000;\n    text-anchor: middle;\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 10px;\n}\n\n.graphic_grid_value{\n    fill: #000;\n    font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
